import { createResource, createEndpoint } from './Schema';
import { UserModel } from './Schema/Models';
import api from './Schema/Api';

/*
 * static s'applique au model
 * methods s'applique à la resource
 */
const sync = false;
const methods = {};

const UserResource = createResource(api, UserModel, {
  static: { sync },
  methods,
});

export const User = createEndpoint(UserResource, '', { static: {} });
